module.exports = __webpack_public_path__ + "fonts/d9f6fb6c6ab46aa23f35b299dbfef860.svg";